// extracted by mini-css-extract-plugin
module.exports = {"Button":"css-modules_Button__MxUv5","count":"css-modules_count__uKP_e","suffix":"css-modules_suffix__9j1a3"};